import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoSolicitudGastosFarmacia = {
  status: number | null;
  statusText: string | null;
};

const getBackendMessage = (err: any) => {
  const responseData = err?.response?.data;

  return (
    (typeof responseData === "string" ? responseData : null) ||
    responseData?.response ||
    responseData?.message ||
    err?.response?.statusText ||
    err?.message ||
    "Error"
  );
};

const useGetInfoSolicitudGastosFarmacia = () => {
  const [loadingGetInfoSolicitudGastosFarmacia, setLoadingGetInfoSolicitudGastosFarmacia] = useState(false);
  const [successGetInfoSolicitudGastosFarmacia, setSuccessGetInfoSolicitudGastosFarmacia] = useState(false);
  const [errorGetInfoSolicitudGastosFarmacia, setErrorGetInfoSolicitudGastosFarmacia] = useState<any>(null);
  const [dataGetInfoSolicitudGastosFarmacia, setDataGetInfoSolicitudGastosFarmacia] = useState<any>(null);
  const [statusGetInfoSolicitudGastosFarmacia, setStatusGetInfoSolicitudGastosFarmacia] =
    useState<StatusGetInfoSolicitudGastosFarmacia>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoSolicitudGastosFarmacia = async (
    userId: string,
    expedienteId: string | number | null = null,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoSolicitudGastosFarmacia(true);
    setSuccessGetInfoSolicitudGastosFarmacia(false);
    setErrorGetInfoSolicitudGastosFarmacia(null);

    try {
      void expedienteId;
      const res = await apiRecord.getInfoSolicitudGastosContingenciaProfesionalFarmacia(userId);

      setStatusGetInfoSolicitudGastosFarmacia({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetInfoSolicitudGastosFarmacia(true);
      setDataGetInfoSolicitudGastosFarmacia(res.data);
      _cb?.(res.data);

      return res.data;
    } catch (err: any) {
      const backendMessage = getBackendMessage(err);

      setStatusGetInfoSolicitudGastosFarmacia({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetInfoSolicitudGastosFarmacia(err);
      console.error("Error en getInfoSolicitudGastosFarmacia:", err);

      throw err;
    } finally {
      setLoadingGetInfoSolicitudGastosFarmacia(false);
    }
  };

  return {
    getInfoSolicitudGastosFarmacia,
    loadingGetInfoSolicitudGastosFarmacia,
    successGetInfoSolicitudGastosFarmacia,
    errorGetInfoSolicitudGastosFarmacia,
    dataGetInfoSolicitudGastosFarmacia,
    statusGetInfoSolicitudGastosFarmacia
  };
};

export default useGetInfoSolicitudGastosFarmacia;
